import { getAudioPackageCode } from '@/utils';
import { ModuleKeyType, PACKAGE_MODULE } from '@/utils/const';
import request, { ErrorType } from '@/utils/request';

import { ApiResult } from '.';

/**
 * 获取素材包列表
 * @param modelKey 功能模块
 * @returns
 */
export const getPackageCodes = async (
  modelKey: ModuleKeyType,
): Promise<ErrorType | string> => {
  return new Promise(async (resolve, reject) => {
    if (
      modelKey === 'LipSyncAudio' ||
      modelKey === 'Audio' ||
      modelKey === 'LipSyncAudioFY'
    ) {
      resolve(getAudioPackageCode(modelKey));
    } else {
      const res = await fetchGroupCodesData(PACKAGE_MODULE[modelKey]);
      if (res.isError) {
        reject(res);
      } else if (res.code === 200) {
        let codes = res.data.map((group: any) => group.groupCode);
        resolve(codes.join(','));
      }
      resolve('');
    }
  });
};

export const fetchGroupCodesData = async (model: string): Promise<ApiResult<any>> => {
  const res = await request('/api/rest/dlt/template/group', {
    method: 'POST',
    data: { model },
  });
  return res;
};

interface template {
  groupCodes: string;
  pageNum: number;
  pageSize: number;
}

/**
 * 脚本数据
 * @param data
 * @returns
 */
export const fetchTemplatesData = async (data: template): Promise<ApiResult<any>> => {
  return new Promise(async (resolve, reject) => {
    const res = await request('/api/rest/dlt/template/detail', {
      method: 'POST',
      data,
    });

    if (res.isError) {
      reject(res);
    } else {
      resolve(res);
    }
  });
};

interface personalType {
  pageSize: number;
  pageNum: number;
  type: string;
}

/**
 * 数字人列表和音色列表
 * */
export const fetchPersonalData = async (data: personalType): Promise<ApiResult<any>> => {
  const res = await request('/api/rest/dlt/template/personal/page', {
    method: 'POST',
    data,
  });
  return res;
};

export interface makeSimpleType {
  event: string;
  datas?: Array<any>;
  data?: Array<any>;
}
/**
 * TTS
 * @param data
 * let eventData = {
      process_event_type: 74,
      tts_forward_event: {
        model_url: audioTemplateData.modelUrl,
        speaker_id: audioTemplateData.templateCode?.toString(),
        content: text,
        lang: audioTemplateData.lang,
        speed: Number(speed),
      },
    };
    { event: JSON.stringify(eventData) }
 * @returns
 */
export const fetchMakeSimple = async (data: makeSimpleType) => {
  const res = await request('/api/rest/dlt/cloud/simple/make', {
    method: 'POST',
    data,
  });
  return res;
};

interface simpleResultType {
  taskState: number;
  extraEventResult: string;
  businessId: number;
  fileUrl: string;
  duration: number;
  engineCode: string;
}
/**
 * 查询文本试听状态
 * state 0-已成功提交给引擎，1-未能成功发给引擎，2-引擎回调返回成功，3-引擎回调返回失败,8-任务已取消
 */
export const fetchQuerySimpleResult = async (
  businessId: any,
): Promise<ApiResult<simpleResultType>> => {
  const res = await request('/api/rest/dlt/cloud/make/queryResult', {
    method: 'POST',
    data: { businessId },
  });
  return res;
};
